/* ============================================================
   ECO SHADES  ·  product page (server-rendered layout)
   custom.js now only handles interactions, not structure.
   ============================================================ */
(function () {
  var LB = { el: null, imgs: [], idx: 0, imgEl: null, countEl: null };
  function buildLightbox(images) {
    if (LB.el || !images.length) return;
    LB.imgs = images;
    var el = document.createElement('div'); el.className = 'rains-lb'; el.setAttribute('hidden', '');
    el.innerHTML =
      '<button class="rains-lb__close" aria-label="Close">✕</button>' +
      '<button class="rains-lb__nav rains-lb__prev" aria-label="Previous">‹</button>' +
      '<div class="rains-lb__stage"><img alt=""></div>' +
      '<button class="rains-lb__nav rains-lb__next" aria-label="Next">›</button>' +
      '<div class="rains-lb__count"></div>';
    document.body.appendChild(el);
    LB.el = el; LB.imgEl = el.querySelector('img'); LB.countEl = el.querySelector('.rains-lb__count');
    el.querySelector('.rains-lb__close').addEventListener('click', closeLightbox);
    el.querySelector('.rains-lb__prev').addEventListener('click', function (e) { e.stopPropagation(); step(-1); });
    el.querySelector('.rains-lb__next').addEventListener('click', function (e) { e.stopPropagation(); step(1); });
    el.addEventListener('click', function (e) { if (e.target === el) closeLightbox(); });
    document.addEventListener('keydown', function (e) {
      if (!LB.el || LB.el.hasAttribute('hidden')) return;
      if (e.key === 'Escape') closeLightbox();
      else if (e.key === 'ArrowLeft') step(-1);
      else if (e.key === 'ArrowRight') step(1);
    });
  }
  function renderLB() { LB.imgEl.src = LB.imgs[LB.idx]; LB.countEl.textContent = (LB.idx + 1) + ' / ' + LB.imgs.length; }
  function openLightbox(i) { if (!LB.el) return; LB.idx = ((i || 0) % LB.imgs.length + LB.imgs.length) % LB.imgs.length; renderLB(); LB.el.removeAttribute('hidden'); document.body.style.overflow = 'hidden'; }
  function closeLightbox() { if (!LB.el) return; LB.el.setAttribute('hidden', ''); document.body.style.overflow = ''; }
  function step(d) { LB.idx = (LB.idx + d + LB.imgs.length) % LB.imgs.length; renderLB(); }

  function initGallery() {
    var marquee = document.querySelector('.rains-marquee'); if (!marquee) return;
    var slides = [].slice.call(marquee.querySelectorAll('.rains-marquee__slide'));
    var map = {}, imgs = [];
    slides.forEach(function (s) {
      var idx = s.dataset.idx; if (map[idx] !== undefined) return;
      var im = s.querySelector('img'); if (!im) return;
      map[idx] = imgs.length; imgs.push(im.getAttribute('src').replace(/width=\d+/, 'width=1600'));
    });
    buildLightbox(imgs);
    slides.forEach(function (s) { s.style.cursor = 'pointer'; s.addEventListener('click', function () { openLightbox(map[s.dataset.idx] || 0); }); });
    [].slice.call(document.querySelectorAll('.rains-desc__img img')).forEach(function (im) {
      im.style.cursor = 'pointer';
      im.addEventListener('click', function () { var k = map[im.dataset.idx]; openLightbox(k === undefined ? 0 : k); });
    });
    function bleed(el) { if (!el) return; el.style.marginLeft = '0'; var l = el.getBoundingClientRect().left; el.style.marginLeft = (-l) + 'px'; }
    function bleedMarquee() { bleed(marquee); }
    bleedMarquee(); window.addEventListener('load', bleedMarquee); var t; window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(bleedMarquee, 150); });
  }

  function layoutBuyBox() {
    var info = document.querySelector('.product-page-info'); if (!info || info.dataset.rainsBb) return;
    var title = info.querySelector('.product-page-info__title'); var price = info.querySelector('.product-page-info__price');
    if (!title || !price) return; info.dataset.rainsBb = '1';
    var head = document.createElement('div'); head.className = 'rains-bb-head';
    title.parentNode.insertBefore(head, title); head.appendChild(title); head.appendChild(price);
  }

  function ensureSizeLine() {
    var info = document.querySelector('.product-page-info'); if (!info) return;
    if (info.querySelector('.product-page-info__options')) return;
    var dataEl = document.querySelector('.rains-size-data');
    var size = dataEl ? dataEl.getAttribute('data-size') : '';
    if (!size) return;
    var wrap = document.createElement('div'); wrap.className = 'product-page-info__options';
    var label = document.createElement('label'); label.textContent = 'Size: ' + size;
    wrap.appendChild(label);
    var head = info.querySelector('.rains-bb-head');
    if (head) head.insertAdjacentElement('afterend', wrap); else info.insertBefore(wrap, info.firstChild);
  }

  function labelAddToCart() {
    var info = document.querySelector('.product-page-info'); if (!info) return;
    var btn = info.querySelector('.product-page-info__button-add-to-cart .btn');
    var priceEl = info.querySelector('.product-page-info__price .price') || info.querySelector('.product-page-info__price');
    if (!btn || !priceEl || btn.dataset.rainsLabel) return;
    var price = priceEl.textContent.replace(/\s+/g, ' ').trim();
    var span = btn.querySelector('span'); if (!span) return;
    var label = (span.textContent || 'Add to cart').replace(/\s+/g, ' ').trim();
    span.textContent = price + ' – ' + label;
    btn.className = btn.className.replace(/\bbtn--animat[\w-]*/g, ' ').replace(/\s+/g, ' ').trim();
    btn.dataset.rainsLabel = '1';
  }

  /* ------------------------------------------------------------------
     Colour group.

     Every colour of a model is its own product, so the swatch row is the
     group. Products are found with a field-scoped search on the model word
     (title:quist) served as JSON by templates/search.colours.liquid.

     Do NOT go back to /search/suggest.json: that endpoint caps at 10
     products (it ignores the requested limit) and pads the leftover slots
     with same-colour products from other models, which silently dropped
     colours from this row - Quist showed 3 of 4, Palazzo 6 of 8.
     ------------------------------------------------------------------ */
  var COLOURS_VIEW = '/search?type=product&view=colours&options[prefix]=last&options[unavailable_products]=show';
  var COLOURS_MAX_PAGES = 5;

  function fetchColourGroup(model) {
    var out = [];
    function page(n) {
      var url = COLOURS_VIEW + '&q=' + encodeURIComponent('title:' + model) + (n > 1 ? '&page=' + n : '');
      return fetch(url).then(function (r) {
        if (!r.ok) throw new Error('colours ' + r.status);
        return r.json();
      }).then(function (data) {
        out = out.concat((data && data.products) || []);
        if (data && data.next && n < COLOURS_MAX_PAGES) return page(n + 1);
        return out;
      });
    }
    return page(1);
  }

  function colourOf(p) {
    if (p.colour && p.colour.length) return [].concat(p.colour).join(' ');
    return String(p.title || '').trim().split(/\s+/).slice(1).join(' ');
  }

  function currentImageSrc() {
    var im = document.querySelector('.rains-marquee__slide img') || document.querySelector('.product-page-main img');
    return im ? im.getAttribute('src') : '';
  }

  function renderColourBox(model, currentColor, currentHandle, products) {
    var info = document.querySelector('.product-page-info');
    if (!info || document.querySelector('.rains-colors')) return;
    var seen = {}, items = [];
    products.forEach(function (p) {
      // title: matches the word anywhere in the title, so keep only real model matches
      var first = String(p.title || '').trim().split(/\s+/)[0] || '';
      if (first.toLowerCase() !== model.toLowerCase()) return;
      var handle = p.handle || (String(p.url || '').match(/\/products\/([^\/?#]+)/) || [])[1];
      if (!handle || seen[handle]) return;
      seen[handle] = 1;
      items.push({ handle: handle, url: p.url, title: p.title, image: p.image, available: p.available !== false, colour: colourOf(p) });
    });
    // a just-published product is not in the search index yet; never let its own page miss it
    if (currentHandle && !seen[currentHandle]) {
      items.push({ handle: currentHandle, url: '/products/' + currentHandle, title: (model + ' ' + currentColor).trim(), image: currentImageSrc(), available: true, colour: currentColor });
    }
    if (items.length < 2) return;
    items.sort(function (a, b) { return String(a.colour).localeCompare(String(b.colour), undefined, { sensitivity: 'base' }); });

    var box = document.createElement('div'); box.className = 'rains-colors';
    box.innerHTML = '<div class="rains-colors__label"><strong>Color</strong> ' + currentColor + '</div>';
    var grid = document.createElement('div'); grid.className = 'rains-colors__grid';
    items.forEach(function (it) {
      var a = document.createElement('a');
      a.className = 'rains-colors__item' + (it.handle === currentHandle ? ' is-current' : '') + (it.available ? '' : ' is-unavailable');
      a.href = it.url; a.title = it.available ? it.title : it.title + ' (sold out)';
      var im = new Image(); im.loading = 'lazy'; im.alt = it.title;
      if (it.image) im.src = it.image;
      if (!it.available) im.style.opacity = '.45';
      a.appendChild(im); grid.appendChild(a);
    });
    box.appendChild(grid); info.insertAdjacentElement('afterend', box); alignBuyBox();
  }

  function buildColorBox(title) {
    var info = document.querySelector('.product-page-info'); if (!info || document.querySelector('.rains-colors')) return;
    var parts = (title || '').trim().split(/\s+/); var model = parts[0]; if (!model) return;
    var currentColor = parts.slice(1).join(' ');
    var currentHandle = (window.location.pathname.match(/\/products\/([^\/?#]+)/) || [])[1];
    function attempt(retry) {
      fetchColourGroup(model).then(function (products) {
        renderColourBox(model, currentColor, currentHandle, products);
      }).catch(function () {
        if (retry) setTimeout(function () { attempt(false); }, 800);
      });
    }
    attempt(true);
  }

  function alignBuyBox() {
    var info = document.querySelector('.product-page .product-page-info'); var row = document.querySelector('.product-page .row');
    if (!info || !row) return;
    if (window.innerWidth < 768) { info.style.marginTop = ''; return; }
    var colors = document.querySelector('.rains-colors'); info.style.marginTop = '0px';
    var rowH = row.getBoundingClientRect().height;
    var stackH = info.getBoundingClientRect().height + (colors ? colors.getBoundingClientRect().height + 14 : 0);
    var top = rowH - stackH - Math.round(rowH * 0.11); if (top < 0) top = 0; info.style.marginTop = top + 'px';
  }

  function syncModelSpeed() {
    var ct = document.querySelector('.rains-marquee__track');
    var mt = document.querySelector('.rains-model__track');
    if (!ct || !mt) return;
    var cw = ct.getBoundingClientRect().width, mw = mt.getBoundingClientRect().width;
    if (!cw || !mw) return;
    var durSec = parseFloat(getComputedStyle(ct).animationDuration) || 0;
    if (!durSec) return;
    var pxPerSec = (cw / 2) / durSec;
    if (pxPerSec <= 0) return;
    mt.style.animationDuration = ((mw / 2) / pxPerSec).toFixed(2) + 's';
  }

  function closeSizeModal() { var el = document.querySelector('.rains-size-modal'); if (el) { el.setAttribute('hidden', ''); document.body.style.overflow = ''; } }
  function openSizeModal(e) {
    if (e) e.preventDefault();
    var el = document.querySelector('.rains-size-modal');
    if (!el) {
      el = document.createElement('div'); el.className = 'rains-size-modal'; el.setAttribute('hidden', '');
      el.innerHTML = '<div class="rains-size-modal__panel"><button class="rains-size-modal__close" aria-label="Close">✕</button><div class="rains-size-modal__body">Loading…</div></div>';
      document.body.appendChild(el);
      el.querySelector('.rains-size-modal__close').addEventListener('click', closeSizeModal);
      el.addEventListener('click', function (ev) { if (ev.target === el) closeSizeModal(); });
      document.addEventListener('keydown', function (ev) { if (!el.hasAttribute('hidden') && ev.key === 'Escape') closeSizeModal(); });
    }
    el.removeAttribute('hidden'); document.body.style.overflow = 'hidden';
    if (el.dataset.loaded) return;
    var body = el.querySelector('.rains-size-modal__body');
    fetch('/pages/size-guide-1').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var content = doc.querySelector('.rte') || doc.querySelector('.main-page__content') || doc.querySelector('[class*="page"] .rte') || doc.querySelector('main');
      body.innerHTML = content ? content.innerHTML : 'Size guide is currently unavailable.'; el.dataset.loaded = '1';
    }).catch(function () { body.textContent = 'Size guide is currently unavailable.'; });
  }
  function bindSizeGuide() {
    var label = document.querySelector('.product-page-info__options label'); if (!label || label.dataset.rainsSize) return;
    label.dataset.rainsSize = '1'; label.classList.add('rains-size-link'); label.addEventListener('click', openSizeModal);
  }

  function init() {
    if (!document.body.classList.contains('template-product')) return;
    if (!document.querySelector('.rains-pp')) return;
    initGallery(); layoutBuyBox(); ensureSizeLine(); labelAddToCart(); bindSizeGuide();
    var titleEl = document.querySelector('.product-page-info__title');
    buildColorBox(titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '');
    function reflow() { alignBuyBox(); syncModelSpeed(); }
    window.addEventListener('load', reflow);
    var rt; window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(reflow, 150); });
    setTimeout(reflow, 600); setTimeout(reflow, 1500);
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
